import { Typography } from '@mui/material';
import { tour_13, tour_13a } from 'constants/tour';

/* import { Check } from '@mui/icons-material';*/
export const steps = [
  {
    selector: `.${tour_13a.step_02}`,
    content: () => {
      return (
        <Typography>
          Clicca qui per compilare la scheda corrente con tutti Visto e NP
        </Typography>
      );
    },
  },
  {
    selector: `.${tour_13.step_01}`,
    content: () => {
      return (
        <Typography>
          Clicca qui per copiare i dati della scheda corrente su un altro
          elemento
        </Typography>
      );
    },
    /* style: {
      backgroundColor: '#bada55',
    }, */
  },
];
